<template>
  <div class="home">
    <a id="show-sidebar" class="btn btn-sm btn-dark" href="#">
      <i class="fas fa-bars"></i>
    </a>
    <nav id="sidebar" class="sidebar-wrapper">
      <div class="sidebar-content">
        <div class="sidebar-brand">
          <div id="close-sidebar" class="d-block d-md-none">
            <i class="fas fa-times"></i>
          </div>
        </div>
        <div class="sidebar-headers mt-5">
          <div class="user-pic">
            <img
              class="img-fluid"
              src="../../assets/images/avatar.jpg"
              alt="User picture"
            />
          </div>
          <div class="user-info">
            <span class="user-name">
              Hi!
              <strong>Admin</strong>
            </span>
          </div>
        </div>
        <!-- sidebar-header  -->

        <!-- sidebar-body  -->
        <div class="sidebar-menu">
          <ul>
            <label class="header-menu">
              <span>Overview</span>
            </label>
            <li :class="{ active: isHome }" @click="home">
              <router-link to="/admin">
                <i class="icons fa fa-home"></i>
                <span class="event">Dashboard</span>
              </router-link>
            </li>
            <li :class="{ active: isAccount }" @click="account">
              <router-link to="/admin/user">
                <i class="icons fa fa-user"></i>
                <span class="event">User Management</span>
              </router-link>
            </li>
            <!-- <li :class="{ active: isTransfer }" @click="transfer">
              <router-link to="/admin/approvals">
                <i class="icons fa fa-check"></i>
                <span class="event">Approvals</span>
              </router-link>
            </li> -->
            <li :class="{ active: isFund }" @click="fund">
              <router-link to="/admin/gl">
                <i class="icons fa fa-user"></i>
                <span class="event">GL Categories</span>
              </router-link>
            </li>
            <li :class="{ active: isMisc3 }" @click="misc3">
              <router-link to="/admin/products">
                <i class="icons fa fa-user"></i>
                <span class="event">Product Categories</span>
              </router-link>
            </li>
            <li class="sidebar-dropdown" :class="{ active: isMisc2 }">
              <a>
                <i class="icons fa fa-chart-line"></i>
                <span class="event">Financial Report</span>
              </a>
              <div class="sidebar-submenu">
                <ul>
                  <li :class="{ active1: isLoan }" @click="loan">
                    <router-link to="/admin/reports/balancesheet"
                      ><span class="event1">Balance Sheet</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isInvestment }" @click="invest">
                    <router-link to="/admin/reports/statement">
                      <span class="event1">Income Statement (P&L)</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isUtility }" @click="utility">
                    <router-link to="/admin/reports/ledger"
                      ><span class="event1">General Ledger</span></router-link
                    >
                  </li>
                  <li :class="{ active1: isMisc1 }" @click="misc1">
                    <router-link to="/admin/reports/trialbalance">
                      <span class="event1">Trial Balance</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidebar-dropdown" :class="{ active: isMisc2 }">
              <a>
                <i class="icons fa fa-chart-line"></i>
                <span class="event">Report</span>
              </a>
              <div class="sidebar-submenu">
                <ul>
                  <li :class="{ active1: isLoan }" @click="loan">
                    <router-link to="/admin/CREDIT/creditreport"
                      ><span class="event1">Daily Credit Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isInvestment }" @click="invest">
                    <router-link to="/admin/CREDIT/loanlisting">
                      <span class="event1">General Loan Listing </span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isUtility }" @click="utility">
                    <router-link to="/admin/CREDIT/productlisting"
                      ><span class="event1"
                        >Product Loan Listing</span
                      ></router-link
                    >
                  </li>
                  <li :class="{ active1: isMisc1 }" @click="misc1">
                    <router-link to="/admin/CREDIT/MaturityReport">
                      <span class="event1">Loan maturity Listing</span>
                    </router-link>
                  </li>
                  <li :class="{ active: isMisc4 }" @click="misc4">
                    <router-link to="/admin/CREDIT/ParReport">
                      <span class="event1">Par Portfolio Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active: isMisc5 }" @click="misc5">
                    <router-link to="/admin/CREDIT/disbursereport">
                      <span class="event1">Disbursement Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active: isMisc6 }" @click="misc6">
                    <router-link to="/admin/CREDIT/RepaymentReport">
                      <span class="event1">Repayment Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active: isMisc7 }" @click="misc7">
                    <router-link to="/admin/CREDIT/CollectionReport">
                      <span class="event1">Collection Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active: isMisc8 }" @click="misc8">
                    <router-link to="/admin/CREDIT/investmentReport">
                      <span class="event1">Daily Investment Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active: isMisc9 }" @click="misc9">
                    <router-link to="/admin/CREDIT/investListingReport">
                      <span class="event1">General Investment Listing</span>
                    </router-link>
                  </li>
                  <li :class="{ active: isMisc10 }" @click="misc10">
                    <router-link to="/admin/CREDIT/maturitylistingReport">
                      <span class="event1">Investment Maturity Listing</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- reports -->
            <!-- <li class="sidebar-dropdown" :class="{ active: isMisc2 }">
              <router-link to="/admin/CREDIT">
                <i class="icons fa fa-chart-line"></i>
                <span class="event">Reports</span>
              </router-link>

               <div class="sidebar-submenu">
                <ul>
                  <li :class="{ active1: isCredit }" @click="credit">
                    <router-link to="/admin/CREDIT/creditreport"
                      ><span class="event1">Daily Credit Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isLlisting }" @click="llisting">
                    <router-link to="/admin/CREDIT/loanlisting">
                      <span class="event1">General Loan Listing </span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isPlisting }" @click="plisting">
                    <router-link to="/admin/CREDIT/productlisting"
                      ><span class="event1"
                        >Product Loan Listing</span
                      ></router-link
                    >
                  </li>
                  <li :class="{ active1: isMaturity }" @click="maturity">
                    <router-link to="/admin/CREDIT/maturitylisting">
                      <span class="event1">Loan maturity Listing</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isPar }" @click="par">
                    <router-link to="/admin/CREDIT/pareport">
                      <span class="event1">Par Portfolio Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isDisburse }" @click="disburse">
                    <router-link to="/admin/CREDIT/disbursereport">
                      <span class="event1">Disbursement Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isRepay }" @click="repay">
                    <router-link to="/admin/CREDIT/repayreport">
                      <span class="event1">Repayment Report</span>
                    </router-link>
                  </li>
                  <li :class="{ active1: isCollect }" @click="collect">
                    <router-link to="/admin/CREDIT/collectreport">
                      <span class="event1">Collection Report</span>
                    </router-link>
                  </li>
                </ul>
              </div> 
            </li> -->
            <li @click="Logout">
              <router-link to="#">
                <i class="icons fa fa-sign-out-alt"></i>
                <span class="event">Logout</span>
              </router-link>
            </li>
          </ul>
        </div>

        <!-- sidebar-menu  -->
      </div>
      <!-- sidebar-content  -->

      <div class="diamond-wrapper">
        <div id="diamond"></div>
      </div>

      <div class="diamond-wrapper-sm">
        <div id="diamond-sm" class="d-none d-md-block"></div>
      </div>
    </nav>
    <!-- sidebar-wrapper  -->

    <!-- page-content" -->
  </div>
  <!-- page-wrapper -->
</template>

<script>
import $ from "jquery";
import { mapState } from "vuex";

export default {
  name: "Sidenav",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isHome: state => state.Misc.isHome,
      isAccount: state => state.Misc.isAccount,
      //isTransfer: state => state.Misc.isTransfer,
      isFund: state => state.Misc.isFund,
      isUtility: state => state.Misc.isUtility,
      isLoan: state => state.Misc.isLoan,
      isInvestment: state => state.Misc.isInvestment,
      isMisc1: state => state.Misc.isMisc1,
      isMisc2: state => state.Misc.isMisc2,
      isMisc3: state => state.Misc.isMisc3,
      isMisc4: state => state.Misc.isMisc4,
      isMisc5: state => state.Misc.isMisc5,
      isMisc6: state => state.Misc.isMisc6,
      isMisc7: state => state.Misc.isMisc7,
      isMisc8: state => state.Misc.isMisc8,
      isMisc9: state => state.Misc.isMisc9,
      isMisc10: state => state.Misc.isMisc10
    })
  },
  methods: {
    home() {
      this.$store.dispatch("home");
    },
    account() {
      this.$store.dispatch("account");
    },
    transfer() {
      this.$store.dispatch("transfer");
    },
    fund() {
      this.$store.dispatch("fund");
    },
    utility() {
      this.$store.dispatch("utility");
    },
    loan() {
      this.$store.dispatch("loan");
    },
    invest() {
      this.$store.dispatch("investment");
    },
    misc1() {
      this.$store.dispatch("misc1");
    },
    misc2() {
      this.$store.dispatch("misc2");
    },
    misc3() {
      this.$store.dispatch("misc3");
    },
    misc4() {
      this.$store.dispatch("misc4");
    },
    misc5() {
      this.$store.dispatch("misc5");
    },
    misc6() {
      this.$store.dispatch("misc6");
    },
    misc7() {
      this.$store.dispatch("misc7");
    },
    misc8() {
      this.$store.dispatch("misc8");
    },
    misc9() {
      this.$store.dispatch("misc9");
    },
    misc10() {
      this.$store.dispatch("misc10");
    },
    Logout() {
      this.$router.push("/admin/login");
      // this.loading = true;
      // this.$store
      //   .dispatch("LOGOUT")
      //   .then(() => this.$router.push("/admin/login"))
      //   .catch(() => this.$toastr.e("Failed"))
      //   .finally(() => (this.loading = false));
    }
  },
  mounted() {
    $(".sidebar-dropdown > a").click(function() {
      $(".sidebar-submenu").slideUp(200);
      if (
        $(this)
          .parent()
          .hasClass("active")
      ) {
        $(".sidebar-dropdown").removeClass("active");
        $(this)
          .parent()
          .removeClass("active");
      } else {
        $(".sidebar-dropdown").removeClass("active");
        $(this)
          .next(".sidebar-submenu")
          .slideDown(200);
        $(this)
          .parent()
          .addClass("active");
      }
    });
    //open and close sidenav
    $("#close-sidebar").click(function() {
      $(".page-wrapper").removeClass("toggled");
    });
    $("#show-sidebar").click(function() {
      $(".page-wrapper").addClass("toggled");
    });
  }
};
</script>

<style lang="scss" scoped>
/* sidenav icon text */
.event {
  font: Regular 24px/31px "Source Sans Pro" !important;
  color: #020100 !important;
  opacity: 0.8;
  font-family: "SourceSansPro-Regular";
}

.event1 {
  font: Regular 24px/31px "Source Sans Pro" !important;
  color: #020100 !important;
  opacity: 0.8;
  font-family: "SourceSansPro-Regular";
}

/* logout icon */
.fa-sign-out-alt {
  margin-left: 0px;
}

/* large diamond shape */
.diamond-wrapper {
  position: relative;
  margin-top: -97vh;
  z-index: 1;
  width: 50%;
}

#diamond {
  width: 0;
  height: 0;
  border: 60px solid transparent;
  border-bottom-color: #fbdfd1;
  position: relative;
  top: -60px;
}
#diamond:after {
  content: "";
  position: absolute;
  z-index: 1;
  left: -60px;
  top: 60px;
  width: 0;
  height: 0;
  border: 60px solid transparent;
  border-top-color: #fbdfd1;
}

/* small dianond shape */
.diamond-wrapper-sm {
  position: relative;
  margin-top: -100px;
  display: flex;
  justify-content: flex-end;
  z-index: 1;
  width: 50%;
  float: right;
  padding-right: 15px;
}

#diamond-sm {
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-bottom-color: #fbdfd1;
  position: relative;
  top: -20px;
}
#diamond-sm:after {
  content: "";
  position: absolute;
  z-index: 1;
  left: -20px;
  top: 20px;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-top-color: #fbdfd1;
}

/* active nav item  */
.active {
  li {
    color: white !important;
  }
  background: $main-color !important;
  .event {
    color: white !important;
  }
  i {
    color: $main-color !important;
  }
}

.active1 {
  li {
    color: white !important;
  }
  background: $main-color !important;
  .event1 {
    color: white !important;
  }
  i {
    color: $main-color !important;
  }
}

.sidebar-dropdown {
  cursor: pointer;
}

.sidebar-submenu {
  background: white !important;
}

.sidebar-submenu li:hover {
  background: $main-color !important;
  .event1 {
    color: #fff !important;
  }
}
</style>
